import type { NodeData } from "#puf/machines/flow.ts";
import { Handle, type Node, type NodeProps, Position } from "@xyflow/react";

type StateFlowNode = Node<NodeData, "state">;

/**
 * Custom xyflow node for a state in the user's machine. Displays the state id
 * and a badge if it's the initial state. Selection styling is driven by xyflow's
 * `selected` prop. Both source + target handles are exposed so transitions can
 * connect either direction; drag-from-handle to a target creates a new transition
 * (handled in MachineCanvas via `onConnect`).
 */
export function StateNode({ id, data, selected }: NodeProps<StateFlowNode>) {
  return (
    <div
      className={`relative px-4 py-2 rounded-md font-mono text-xs font-semibold tracking-wider min-w-25 text-center ${
        selected
          ? "bg-[color-mix(in_srgb,var(--color-accent)_22%,var(--color-bg-3))] border-2 border-accent text-accent"
          : "bg-bg-3 border border-line text-text"
      }`}
    >
      <Handle type="target" position={Position.Left} className="bg-line! border-line! w-2! h-2!" />
      {data.isInitial && (
        <span className="absolute -top-2 -left-2 bg-accent text-bg text-[9px] font-bold px-1.5 py-0.5 rounded-sm">
          INIT
        </span>
      )}
      <span>{id}</span>
      <Handle type="source" position={Position.Right} className="bg-line! border-line! w-2! h-2!" />
    </div>
  );
}
